import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { pageTitle, tabRail } from '../app/glass/styles';
import Orders from './Orders';
import Returns from './Returns';
import Exchanges from './Exchanges';

const TABS = [
  ['orders', 'navigation.orders'],
  ['sdd', 'navigation.sdd'],
  ['returns', 'navigation.returns'],
  ['exchanges', 'navigation.exchanges'],
];

export default function OrdersHub() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const orderId = searchParams.get('order');
  const tab = TABS.some(([k]) => k === tabParam) ? tabParam : 'orders';

  if (orderId) {
    navigate(`/orders/${orderId}`, { replace: true });
    return null;
  }

  const setTab = (key) => {
    const next = new URLSearchParams(searchParams);
    if (key === 'orders') next.delete('tab');
    else next.set('tab', key);
    // Each hub list is a different query — never keep another tab's page or status.
    next.delete('page');
    next.delete('status');
    next.delete('search');
    next.delete('filters');
    setSearchParams(next, { replace: true });
  };

  return (
    <>
      <div className="cz-wrap" style={{ display: 'flex', alignItems: 'center', gap: 24, marginTop: 6 }}>
        <div style={pageTitle}>{t('navigation.orders')}</div>
        <div className="cz-scroll-x" style={{ ...tabRail, marginInlineStart: 'auto' }}>
          {TABS.map(([key, label]) => (
            <button key={key} type="button" className={`cz-tab ${tab === key ? 'on' : ''}`} onClick={() => setTab(key)}>
              {t(label)}
            </button>
          ))}
        </div>
      </div>
      {tab === 'orders' && <Orders key="orders" />}
      {tab === 'sdd' && <Orders key="sdd" sddOnly />}
      {tab === 'returns' && <Returns key="returns" />}
      {tab === 'exchanges' && <Exchanges key="exchanges" />}
    </>
  );
}
